export const PROVIDER = 'provider';
export const CUSTOMER = 'customer';
